module.exports = __webpack_public_path__ + "static/media/journal-number.89628fe1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/journal-number.svg
// module id = 169
// module chunks = 0